import { defineStore } from "pinia";
import { fetchBannerData } from "@/api/banner";

export const bannerStore = defineStore("banner", {
    state: () => ({
        banners: [],
        banner: null,
    }),

    actions: {
        async loadBanners() {
            const res = await fetchBannerData()
            const banners = res.data.data
            this.banners = Array.isArray(banners)
                ? banners
                : [banners]
        },
    }
});